import type { IconData } from '@stacksjs/iconify-core'

export const pencil: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m29.663 482.25l.087.087a24.85 24.85 0 0 0 17.612 7.342a25.2 25.2 0 0 0 8.1-1.345l142.006-48.172l272.5-272.5A88.832 88.832 0 0 0 344.334 42.039l-272.5 272.5l-48.168 142.002a24.84 24.84 0 0 0 5.997 25.709m337.3-417.584a56.832 56.832 0 0 1 80.371 80.373L411.5 180.873L331.127 100.5ZM99.744 331.884L308.5 123.127l80.373 80.373l-208.757 208.756l-121.634 41.262Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pencil
